/* eslint-disable no-console */
import { client } from ".";

// Hard delete REAL. Devuelve { data, error } (sin relanzar) para que el front decida el mensaje.
// FK violation (Postgres 23503): el usuario tiene registros asociados en tablas NO ACTION
// (ventas, cobros, etc.) → el delete se bloquea y el front muestra un mensaje específico.
// clientes_contactos_agencia/cliente son ON DELETE CASCADE → se borran junto al usuario.
export const deleteUsuario = async (id) => {
  const { data, error } = await client.from("usuarios").delete().eq("id", id).select();

  if (error) {
    console.error("Error en deleteUsuario:", error);
  }

  return { data, error };
};
